export default {
    messageData: (state = {}) => state,
};
